<template>
    <div>

        <!-- Start Services Details Area -->
		<section class="services-details-area ptb-80 mt-5">
			<div class="container">
				<div class="section-title">
                <h2>IT consultancy</h2>
                <div class="bar"></div>
            </div>
				<div class="row align-items-center">
					<div class="col-lg-6 services-details">
						<div class="services-details-desc">
							<p> As your business grows it is important to look at the bigger aspect and invest into a good IT consultancy which will drastically improve your business in the long run.Hiring a permanent IT expert is very expensive in the long run that is why you need a good IT consultant that can help you to save a lot of money. Our IT consultant team will help you to save a lot of money using the things that you already have and answering your business</p>
							<p>Hiring a permanent IT expert is very expensive in the long run that is why you need a good IT consultant that can help you to save a lot of money. Our IT consultant team will help you to save a lot of money using the things that you already have and answering your business </p>
						</div>
					</div>

					<div class="col-lg-6 services-details-image">
						<img src="../../../../assets/img/services-details-image/1.png" class="wow fadeInUp" v-wow alt="image">
					</div>
				</div>

				<div class="separate"></div>

				<div class="row align-items-center">
					<div class="col-lg-6 services-details-image">
						<img src="../../../../assets/img/services-details-image/2.png" class="wow fadeInUp" v-wow alt="image">
					</div>

					<div class="col-lg-6 services-details">
						<div class="services-details-desc">
							<p> Data security is one of the utmost priorities of WB softwares. As a leading IT consultancy firm, we always make your data as secure as possible.Our team will also help you improve your customer service and productivity without any hassle.With our IT consultancy services you will also have the benefit of professional IT services that your business will need on a daily basis. </p>

							<div class="services-details-accordion">
								<VueFaqAccordion 
									:items="myItems"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
        <!-- End Services Details Area -->
    </div>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion';
export default {
	name: 'ITConsultancy',
	components: {
        VueFaqAccordion
    },
    data() {
        return {
            text: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute.`,
             myItems: [
                {
                    title: 'Innovative Technology',
                    value: 'We leverage cutting-edge technology and methodologies to develop powerful sales automation software.'
                },
                {
                    title: 'Customer Partners',
                    value: 'We apply deep domain and hosting knowledge to support our clients’ technology and business goals.'
                },
                {
                    title: 'First-Rate Services',
                    value: 'We are committed to delivering best-in-class technology and customer service, building long lasting business partnerships.'
                }
            ]
        }
    }
}
</script>